import FormContainer from '@shared/FormContainer/components/FormContainer';

export default FormContainer;
